/* ============================================================
   ONE Coffee — adaugare in cos.

   De ce exista fisierul asta: formularele noastre de adaugare in
   cos sunt scrise de mana, in afara componentelor Horizon. Cand
   tema isi ataseaza propriile ascultatoare pe formularele care
   trimit catre /cart/add, poate opri trimiterea fara sa spuna
   nimic — butonul pare mort.

   Aici preluam noi trimiterea, in faza de captare, inainte sa
   apuce altcineva, o facem prin /cart/add.js si aratam clar ce
   s-a intamplat: confirmare cu link catre cos, sau exact mesajul
   de eroare venit de la Shopify.

   Stilurile notificarii sunt injectate de aici, nu din foaia de
   stil globala, pentru ca notificarea exista doar cand ruleaza
   scriptul. Culorile vin tot din variabilele sistemului de design.
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_URL = root + 'cart/add.js';
  var CART_URL = root + 'cart';

  var CSS =
    '.one-toasts{position:fixed;z-index:9999;left:50%;transform:translateX(-50%);bottom:16px;' +
    'display:flex;flex-direction:column;gap:8px;width:min(420px,calc(100vw - 32px));pointer-events:none}' +
    '@media(min-width:760px){.one-toasts{left:auto;right:24px;bottom:24px;transform:none}}' +
    '.one-toast{pointer-events:auto;background:var(--one-800,#103C43);color:#fff;' +
    'border-radius:var(--one-r-card,12px);padding:14px 18px;font-size:var(--one-t-body,.9375rem);' +
    'line-height:1.5;box-shadow:0 12px 32px -16px rgba(0,0,0,.6);' +
    'opacity:0;transform:translateY(8px);transition:opacity .2s ease,transform .2s ease}' +
    '.one-toast.is-in{opacity:1;transform:none}' +
    '.one-toast--error{background:var(--one-bad,#A93521);cursor:pointer}' +
    '.one-toast__link{display:inline-block;margin-left:10px;color:#fff;font-weight:700;' +
    'text-decoration:none;border-bottom:1px solid currentColor;white-space:nowrap}';

  function injectStyles() {
    if (document.getElementById('one-cart-styles')) return;
    var s = document.createElement('style');
    s.id = 'one-cart-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* Formularele noastre: pagina de produs, cardurile ONE de peste tot
     (colectie, prima pagina, produse inrudite) si orice formular marcat
     explicit. Daca apare un card nou, e destul sa fie in .one-card. */
  function isOurForm(form) {
    if (form.hasAttribute('data-one-addform') || form.id === 'pdp-form') return true;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return false;
    return !!(form.closest('[data-one-card]') || form.closest('.one-card'));
  }

  /* --- notificare -------------------------------------------- */
  var host = null;

  function ensureHost() {
    if (host && document.body.contains(host)) return host;
    injectStyles();
    host = document.createElement('div');
    host.className = 'one-toasts';
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    return host;
  }

  function toast(html, kind) {
    var box = document.createElement('div');
    box.className = 'one-toast' + (kind === 'error' ? ' one-toast--error' : '');
    box.innerHTML = html;
    ensureHost().appendChild(box);
    requestAnimationFrame(function () { box.classList.add('is-in'); });
    if (kind === 'error') {
      box.addEventListener('click', function () { box.remove(); });
    } else {
      setTimeout(function () {
        box.classList.remove('is-in');
        setTimeout(function () { box.remove(); }, 260);
      }, 6000);
    }
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* --- contorul din antet ------------------------------------ */
  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function () { /* contorul nu e critic */ });
  }

  /* --- trimiterea -------------------------------------------- */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !isOurForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var btn = form.querySelector('button[type="submit"]');
      var outside = form.id ? document.querySelector('button[form="' + form.id + '"]') : null;
      var label = btn ? btn.textContent : '';

      function lock(on) {
        [btn, outside].forEach(function (b) {
          if (!b) return;
          b.disabled = on;
        });
        if (btn) btn.textContent = on ? 'Se adaugă…' : label;
      }

      var data = new FormData(form);
      if (!data.get('quantity')) data.set('quantity', '1');

      /* Macinarea e obligatorie la cafea. Validarea nativa o prinde deja;
         asta e plasa pentru browsere care sar peste ea. */
      var grindBox = form.querySelector('[data-grind]');
      if (grindBox && !data.get('properties[Măcinare]')) {
        toast('<strong>Alege cum vrei măcinată cafeaua</strong><br>Boabe întregi, French press, Filtru, V60, Espresso sau Ibric.', 'error');
        grindBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (!data.get('id')) {
        toast('Nu am putut identifica varianta aleasă. Reia selecția de gramaj și măcinare.', 'error');
        return;
      }

      lock(true);

      fetch(ADD_URL, { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (result) {
          lock(false);
          if (!result.ok) {
            var msg = (result.body && (result.body.description || result.body.message)) || 'Produsul nu a putut fi adăugat în coș.';
            toast('<strong>Nu s-a putut adăuga</strong><br>' + esc(msg), 'error');
            return;
          }
          var title = (result.body && result.body.product_title) || 'Produsul';
          toast(
            '<strong>' + esc(title) + '</strong> a fost adăugat în coș.' +
              '<a class="one-toast__link" href="' + CART_URL + '">Vezi coșul →</a>'
          );
          refreshCount();
        })
        .catch(function (error) {
          lock(false);
          toast('<strong>Conexiune întreruptă</strong><br>' + esc(error && error.message), 'error');
        });
    },
    true
  );
})();

/* ============================================================
   Poza variantei pe pagina de produs.
   Cand clientul alege o varianta (culoare, grupuri, executie) care
   are poza ei in Shopify, poza mare se schimba pe poza variantei.
   Datele vin din /products/<handle>.js, o singura data per pagina.
   Produsele fara poze pe variante raman neatinse.
   ============================================================ */
(function () {
  'use strict';

  function init() {
  var form = document.getElementById('pdp-form');
  var main = document.getElementById('pdp-main');
  var idInput = document.getElementById('pdp-variant');
  if (!form || !main || !idInput) return;

  var path = window.location.pathname.replace(/\/$/, '');
  if (path.indexOf('/products/') === -1) return;

  var map = null;
  var last = null;

  function sized(src) {
    if (!src) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
  }

  function apply() {
    if (!map) return;
    var id = String(idInput.value);
    if (id === last) return;
    last = id;
    var src = map[id];
    if (!src) return;
    main.src = sized(src);
    var thumbs = document.querySelectorAll('[data-pdp-thumbs] .pdp__thumb');
    var base = src.split('?')[0].split('/').pop();
    Array.prototype.forEach.call(thumbs, function (b) {
      var t = (b.dataset.src || '').split('?')[0].split('/').pop();
      b.setAttribute('aria-pressed', t === base ? 'true' : 'false');
    });
  }

  fetch(path + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants) return;
      var m = {};
      var any = false;
      p.variants.forEach(function (v) {
        if (v.featured_image && v.featured_image.src) {
          m[String(v.id)] = v.featured_image.src;
          any = true;
        }
      });
      if (!any) return;
      map = m;
      if (/[?&]variant=/.test(window.location.search)) apply();
      else last = String(idInput.value);
    })
    .catch(function () {});

  form.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-opt]')) return;
    setTimeout(apply, 0);
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
